import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import Navbar from "./components/Nav/Navbar";
import { Route, Routes } from "react-router-dom";
import Price from "./Pages/Price";
import Gallery from "./Pages/Gallery/Gallery";
import GalleryPage1 from "./Pages/Gallery/GalleryPage1";
import About from "./Pages/About";
import Testimonials from "./components/Testimonials/Testimonials";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="contact" element={<Contact />} />
        <Route path="pricing" element={<Price />} />{/**/}
        <Route path="about" element={<About />} />
        <Route path="Testimonials" element={<Testimonials/>}/>
        <Route path="gallery" element={<Gallery />}>
          <Route path="page-1" element={<GalleryPage1 />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
